export default __webpack_public_path__ + "static/media/digital.575aa645.png";